import React from 'react';

import { PageHeaderActions, PageHeaderMeta, PageHeaderWrapper } from './PageHeader.styles';
import { PageHeaderProps } from './PageHeader.types';

export const PageHeader = ({ children, actions, meta, className }: PageHeaderProps) => (
  <PageHeaderWrapper className={`page-header ${className || ''}`} meta={!!meta}>
    {children}

    {actions && <PageHeaderActions className="page-header__actions">{actions}</PageHeaderActions>}

    {!!meta && <PageHeaderMeta>{meta}</PageHeaderMeta>}
  </PageHeaderWrapper>
);
